import { useContent } from "../../../context/ContentContext";
import { Editable, Sortable } from "../../../context/design";

const bgColors = ["bg-sky-100", "bg-teal-50", "bg-slate-100", "bg-stone-50"];
const imageSeqs = ["feat1", "feat2", "feat3", "feat4"];

export default function FeaturesSection() {
  const { features } = useContent();

  return (
    <section id="features" className="relative py-20 md:py-32 w-full bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20">
        <div className="max-w-4xl mb-16 md:mb-24">
          <Editable as="p" id="features.label" label="Kleine Beschriftung" className="text-sm text-sky-600 font-medium tracking-widest uppercase mb-4">{features.label}</Editable>
          <Editable as="h2" id="features.title" label="Überschrift" className="text-3xl sm:text-4xl md:text-5xl font-bold text-sky-950 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            {features.title_line1}<br />
            <span className="italic font-normal text-sky-600">{features.title_italic}</span>
          </Editable>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.items.map((feature, index) => (
            <Sortable key={index} path={["features", "items"]} index={index} className="group relative rounded-3xl overflow-hidden bg-white border border-sky-100 hover:border-sky-200 transition-all duration-300">
              <div className={`relative h-72 md:h-80 ${bgColors[index % bgColors.length]} overflow-hidden`}>
                <img
                  src={feature.image || `https://readdy.ai/api/search-image?query=soft%20abstract%20light%20blue%20watercolor%20texture%20minimal%20gentle%20calming%20ethereal%20pastel%20serene%20artistic%20background%20high%20quality&width=400&height=500&seq=${imageSeqs[index % imageSeqs.length]}&orientation=portrait`}
                  alt={feature.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{ objectPosition: "top" }}
                />
              </div>
              <div className="p-5 md:p-6">
                <Editable as="h3" id={`features.items.${index}.title`} label={`Karte ${index + 1} – Titel`} className="text-lg font-bold text-sky-900 mb-2">{feature.title}</Editable>
                <Editable as="p" id={`features.items.${index}.description`} label={`Karte ${index + 1} – Text`} className="text-sm text-sky-700/80 leading-relaxed">{feature.description}</Editable>
              </div>
            </Sortable>
          ))}
        </div>
      </div>
    </section>
  );
}
